import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormLabel from "@material-ui/core/FormLabel";
import ContentEditable from "react-contenteditable";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import Radio from "@material-ui/core/Radio";
import { connect } from "react-redux";
import { Button, Form, FormGroup, Label, Input, FormText, Spinner } from "reactstrap";
import { CheckCircleOutlined, CheckBoxOutlineBlank } from "@material-ui/icons";
import CheckBoxTwoToneIcon from "@material-ui/icons/CheckBoxTwoTone";
import Media from "react-media";

class JirangoCheckbox2 extends React.Component {
  setLabelPosition = (placement, matches) => {
    if (matches.small || this.props.previewDevice === "smartphone") return { display: "inline-flex", lineHeight: "40px", flexDirection: "row" };
    switch (placement) {
      case "start":
        return { display: "inline-flex", lineHeight: "40px", flexDirection: "row-reverse" };
      case "end":
        return { display: "inline-flex", lineHeight: "40px", flexDirection: "row" };
      case "top":
        return { display: "inline-flex", flexDirection: "column-reverse" };
      case "under":
        return { display: "inline-flex", flexDirection: "column" };
      default:
        return { display: "inline-flex", lineHeight: "40px", flexDirection: "row" };
    }
  };
  setLabelTextAlignment = (placement, smartphone) => {
    if (smartphone || this.props.previewDevice === "smartphone") return "left";
    switch (placement) {
      case "start":
        return "right";
      case "end":
        return "left";
      case "top":
        return "center";
      case "under":
        return "center";
      default:
        return "center";
    }
  };
  setMargin = (inline) => {
    const { optionSpacing } = this.props;
    if (inline) return `0px ${parseInt(optionSpacing)}px`;
    else return `${parseInt(optionSpacing)}px 0px`;
  };
  checkAdapter = (e, id) => {
    if (this.props.cms.editMode) return;
    this.props.checkOnchange(e.target.checked, id);
  };
  drawLabel = (smartphone, isHidden) => {
    const { isReadonly, labelPlacement, labelName, checkboxIsDisabled, textStyle, id, editable, labelOnchange, previewDevice, systemLabel = false } = this.props;
    if (isHidden && !smartphone && previewDevice !== "smartphone") return null;
    else {
      return editable ? (
        <React.Fragment>
          <ContentEditable
            innerRef={this.contentEditable}
            onChange={(e) => labelOnchange(e.target.value, id)}
            style={{
              ...textStyle,
              cursor: isReadonly || checkboxIsDisabled ? "not-allowed" : "pointer",
              margin: "0px",
              textAlign: this.setLabelTextAlignment(labelPlacement, smartphone),
              minWidth: "30px",
              marginTop: labelPlacement === "start" || labelPlacement === "end" || smartphone || previewDevice === "smartphone" ? "15px" : "unset" /*  cursor: 'pointer',  */,
              lineHeight: labelPlacement === "start" || labelPlacement === "end" || smartphone || previewDevice === "smartphone" ? "19px" : "unset" /*  cursor: 'pointer' */,
            }}
            html={labelName !== "" ? labelName : "&nbsp;&nbsp;"}
            className="cms-edit-label"
            tagName="p"
          />
        </React.Fragment>
      ) : (
        <p
          style={{
            ...textStyle,
            cursor: isReadonly || checkboxIsDisabled ? "not-allowed" : "pointer",
            margin: "0px",
            textAlign: this.setLabelTextAlignment(labelPlacement, smartphone),
            marginTop: labelPlacement === "start" || labelPlacement === "end" || smartphone || previewDevice === "smartphone" ? "15px" : "unset" /*  cursor: 'pointer', */,
            lineHeight: labelPlacement === "start" || labelPlacement === "end" || smartphone || previewDevice === "smartphone" ? "19px" : "unset" /*  cursor: 'pointer' */,
          }}
        >
          {systemLabel ? <SystemLabel name={labelName} languageCode={this.props.languageCode} /> : <div dangerouslySetInnerHTML={{ __html: labelName }} />}
        </p>
      );
    }
  };
  render() {
    const {
      labelPlacement = "end",
      editable,
      labelname,
      textStyle,
      id,
      hideCheckbox,
      labelOnchange,
      checkOnchange,
      labelName = "text",
      isSelected = false,
      checkboxIsDisabled,
      boxType,
      boxStyle,
      previewDevice,
      loaderIcon = false,
      replacementContent,
      isReadonly,
      optionSpacing = null,
      inline = false,
      hideLabels = false,
      cms,
    } = this.props;
    return (
      <FormGroup style={{ margin: this.setMargin(inline), display: "inline-flex" }}>
        <Media
          queries={{
            small: "(max-width: 599px)",
            medium: "(min-width: 600px) and (max-width: 1199px)",
            large: "(min-width: 1200px)",
          }}
        >
          {(matches) => (
            <React.Fragment>
              {boxType === "checkbox" ? (
                !hideCheckbox ? (
                  <Checkbox
                    icon={loaderIcon ? <Spinner style={{ color: boxStyle.backgroundColor, borderWidth: "0.15rem", height: "24px", width: "24px" }} /> : <CheckBoxOutlineBlank />}
                    disableRipple={checkboxIsDisabled || isReadonly}
                    id={"my-input"}
                    checked={isSelected}
                    style={{
                      color: boxStyle.backgroundColor,
                      opacity: !cms.editMode && (isReadonly || checkboxIsDisabled) ? "0.5" : 1,
                      cursor: !cms.editMode && (isReadonly || checkboxIsDisabled) ? "not-allowed" : "pointer",
                    }}
                    onChange={(e) => (!checkboxIsDisabled && !isReadonly ? this.checkAdapter(e, id) : null)}
                    color="primary"
                  />
                ) : (
                  replacementContent
                )
              ) : (
                <Radio
                  disableRipple={checkboxIsDisabled || isReadonly}
                  id={"my-input"}
                  checked={isSelected}
                  style={{
                    color: boxStyle.backgroundColor,
                    opacity: !cms.editMode && (isReadonly || checkboxIsDisabled) ? "0.5" : 1,
                    cursor: !cms.editMode && (isReadonly || checkboxIsDisabled) ? "not-allowed" : "pointer",
                  }}
                  onChange={(e) => (!checkboxIsDisabled && !isReadonly ? this.checkAdapter(e, id) : null)}
                  color="primary"
                />
              )}
              <Label style={{ ...this.setLabelPosition(labelPlacement, matches), marginBottom: "0px" }}>{this.drawLabel(matches.small, hideLabels, previewDevice)}</Label>
            </React.Fragment>
          )}
        </Media>
      </FormGroup>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedElement: state.form.selectedElement,
    language: state.language,
    template: state.template,
    form: state.form,
    cms: state.cms,
    attendee: state.attendee,
  };
}

export default connect(mapStateToProps)(JirangoCheckbox2);

const editableLabel = (editable, onChange, style = {}, value) => {
  return editable ? (
    <React.Fragment>
      <ContentEditable onChange={(e) => onChange(e)} style={{ ...style, margin: "0px" }} html={value} tagName="p" />
    </React.Fragment>
  ) : (
    <SystemLabel name={value} />
  );
};
